// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-button-addButton-97155{align-items:center;display:flex;font-size:14px;justify-content:center}.add-button-addButton-97155 .acuicon{margin-right:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addButton": "add-button-addButton-97155"
};
export default ___CSS_LOADER_EXPORT___;
